export default function CardsModule(element) {

    let tl = gsap.timeline({
        scrollTrigger: { trigger:element, end: 'top 500px' }
    });

    let $cards = element.querySelectorAll('.card');
    
    $cards.forEach((elem, index) => {
        let fromY = (window.innerWidth + (index * 1000));
        tl.from(elem, {rotate: 'random(-50, 50)', y: fromY}, '<')
    });

    // const swiper = new Swiper(element, {
    //     pagination: {
    //         el: '.swiper-pagination',
    //     },
    //     // centeredSlides: true,
    //     centerInsufficientSlides: true,
    //     slidesPerView: 1, // max-width: 550px
    //     spaceBetween: 0,
    //     breakpoints: {
    //         550: { // max-width: 767px
    //             slidesPerView: 1,
    //        },
    //         767: { // max-width: 991px
    //             slidesPerView: 2,
    //         },
    //         992: { // max-width: 1350px
    //             slidesPerView: 3,
    //         },
    //         1351: { 
    //             slidesPerView: 4,
    //             spaceBetween: 0,
    //         }
    //     }
    // });
    

    return this;
}
